module.exports = __webpack_public_path__ + "img/served_by_bot.de3eb9d3.svg";